<template>
  <div class="quiz first">
    <h3 class="quizTitle">{{this.$store.state.itemMeta.title}}</h3>

    <div class="exampleWrap text_ex">
      <div class="example" v-bind:key="bogi.id" v-for="bogi in bogis">
        <input
          :disabled="qdis"
          type="checkbox"
          :id="bogi.kid"
          v-model="bogi.checked"
          @change="toggleBogi(bogi)"
        />
        <label :for="bogi.kid">
          <div class="num">{{bogi.index}}</div>
          <div class="text">{{bogi.title}}</div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["issent"],
  data() {
    return {
      bogis2: [...this.$store.getters.getItemMeta.details]
    };
  },
  computed: {
    bogis() {
      return this.$store.getters.getItemMeta.details;
    },
    qdis() {
      return this.issent ? "disabled" : null;
    }
  },
  methods: {
    toggleBogi(bogi) {
      let that = this;

      let answer_flag = this.$store.state.itemMeta.answer_flag;

      if (answer_flag === "A") {
        this.bogis.forEach((b, i) => {
          let f4 = that.bogis[i];
          if (f4.id !== bogi.id) {
            f4.checked = false;
            that.$set(that.bogis, i, f4);
          }
        });
        this.$store.state.itemMeta.my_answers.clear();
        if (bogi.checked) {
          this.$store.state.itemMeta.my_answers.add(bogi.id);
        }
      } else {
        if (this.$store.state.itemMeta.my_answers.has(bogi.id)) {
          this.$store.state.itemMeta.my_answers.delete(bogi.id);
        } else {
          this.$store.state.itemMeta.my_answers.add(bogi.id);
        }
      }
      console.log(this.$store.state.itemMeta.my_answers);
    }
  }
};
</script>


<style lang="scss" scoped>
</style>